import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
// import VueI18n from "vue-i18n";

//plugins
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import { i18n } from "./plugins/i18n";

import "./assets/css/style.css";

// router&store setup
import router from "./router";
import store from "./store";
import auth from "./plugins/auth";
import formatCurrency from "./plugins/formatCurrency";
import objectRoute from "./plugins/objectRoute";
import objectDenomination from "./plugins/objectDenomination";
import flatPickrLocale from "./plugins/flatPickrLocale";
import fillUserOrganizationData from "./plugins/fillUserOrganizationData";
import fillUserResellerData from "./plugins/fillUserResellerData";
import showRequestError from "./plugins/showRequestError";
import fillUserCafeteriasData from "./plugins/fillUserCafeteriasData";
import VueScrollTo from "vue-scrollto";
import timeZoneDateFormat from "./plugins/timeZoneDateFormat";
import formatDate from "./plugins/formatDate";
import stateName from "./plugins/stateName";
import files from "./plugins/files";
import getProductUnitOfMeasureUnitPrice from "./plugins/getProductUnitOfMeasureUnitPrice";
import unaccent from "./plugins/unaccent";

const moment = require("moment");
import 'moment-timezone';
require("moment/locale/fr");

Vue.use(require("vue-moment"), {
  moment,
});

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(auth);
Vue.use(VueMeta, { keyName: "head" });
// Vue.use(VueI18n);
Vue.use(formatCurrency);
Vue.use(objectRoute);
Vue.use(objectDenomination);
Vue.use(flatPickrLocale);
Vue.use(fillUserOrganizationData);
Vue.use(fillUserResellerData);
Vue.use(fillUserCafeteriasData);
Vue.use(showRequestError);
Vue.use(formatDate);
Vue.use(stateName);
Vue.use(timeZoneDateFormat);
Vue.use(getProductUnitOfMeasureUnitPrice);
Vue.use(files);
Vue.use(unaccent);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   render: h => h(App),
//   router
// });
/* eslint-disable no-new */


const timeZone = moment().utcOffset();

// If 2FA was pending and user refreshed, clear the invalid token
if (sessionStorage.getItem("2fa_pending")) {
  localStorage.removeItem("vue-authenticate.vueauth_access_token");
  sessionStorage.removeItem("2fa_pending");
}

let isLoggingOut = false;
axios.interceptors.request.use((config) => {
  config.headers['X-client-timezone'] = moment.tz.guess();
  config.headers['X-client-locale'] = 'fr';
  return config;
});
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !isLoggingOut) {
      isLoggingOut = true;
      store.dispatch("logout").then(() => {
        console.log("logged out");
        isLoggingOut = false;
      }).catch(() => {
        isLoggingOut = false;
      });
    }
    return Promise.reject(error);
  }
);


const app = new Vue({
  i18n: i18n,
  router: router,
  store: store,
  el: "#app",
  render: (h) => h(App),
});

store.$app = app;
